<!--  -->
<template>
  <div style="padding:20px">
    <div class="search_box">
      <div>
        <el-input v-model="pageIfon.keyword" style="width:200px;margin:0px 10px" placeholder="请输入appid或者小程序名" />
        <el-button type="primary" icon="el-icon-search" @click="searchr">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" style="margin-bottom:10px" @click="add">新增</el-button>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="item,index in selectoptions"
        :key="index"
        :label="item.name"
        :name="item.id"
      >
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          @cell-dblclick="celledit"
        >
          <el-table-column
            prop="mini_program_app_id"
            label="小程序appid"
            width="180"
            align="center"
          />
          <el-table-column
            prop="ad_id"
            label="广告id"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{ scope.row.edit }} -->
              <el-input
                v-if="scope.row.edit"
                ref="kpi"
                v-model="scope.row.ad_id"
                style=" 100%"
                @blur="changeData(scope.row)"
              />
              <span v-else @click="wiew(scope.row)">{{ scope.row.ad_id }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="accounts_name"
            label="小程序名"
            width="180"
            align="center"
          />
          <el-table-column
            prop="admin_name"
            label="管理员名"
            width="180"
            align="center"
          />
          <el-table-column
            prop="ad_type_text"
            label="广告类型"
            width="180"
            align="center"
          />
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            width="180"
            align="center"
          />
          <el-table-column
            prop="created_at_text"
            label="状态修改"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="开"
                inactive-text="关"
                :active-value="1"
                :inactive-value="2"
                @change="dawr(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column
            prop="status_text"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
              <i v-if="scope.row.status == 2" class="el-icon-error stopew" />
              {{ scope.row.status_text }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="work_status"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button type="danger" size="mini" style="margin-bottom:10px" @click="delewr(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="30%"
    >
      <daiw @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import { appletsadvlist, updateMiniProgramAd, delMiniProgramAd } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import daiw from './components/daiw.vue'
export default {
  components: {
    PaginationRight,
    daiw
  },
  data() {
    return {
      activeName: '1',
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        keyword: null
      },
      dialogVisible: false,
      selectoptions: [
        {
          id: '1',
          name: ' Banner广告'
        },
        {
          id: '2',
          name: ' 激励广告'
        },
        {
          id: '3',
          name: ' 插屏广告'
        },
        {
          id: '4',
          name: ' 视频广告'
        },
        {
          id: '5',
          name: '视频贴片广告'
        },
        {
          id: '6',
          name: '格子广告'
        },
        {
          id: '7',
          name: '封面广告 '
        },
        {
          id: '8',
          name: '原生模板广告 '
        }
      ],
      tableData: []
    }
  },
  created() {
    this.exchangedata()
  },
  mounted() {

  },
  methods: {
    handleClick() {
      console.log('activeName', this.activeName)
      this.pageIfon.page = 1
      this.exchangedata()
    },
    async exchangedata() {
      const data = await appletsadvlist({
        page: this.pageIfon.page,
        page_size: this.pageIfon.pageSize,
        keyword: this.pageIfon.keyword,
        ad_type: this.activeName
      })
      this.tableData = data.data.list
      data.data.list.forEach(item => {
        item.edit = false
      })
      this.total = data.data.total
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.exchangedata()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.exchangedata()
    },
    add() {
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.exchangedata()
    },
    async dawr(item) {
      console.log('item', item)
      const data = await updateMiniProgramAd({
        id: item.id,
        mini_program_app_id: item.mini_program_app_id,
        ad_id: item.ad_id,
        ad_type: item.ad_type,
        status: item.status
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.exchangedata()
      console.log('data', data)
    },
    delewr(id) {
      console.log('id', id)
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delMiniProgramAd({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.exchangedata()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    celledit(row, column) {
      console.log('row', row, column)
      if (row) {
        row.edit = true
        setTimeout(() => {
          this.$refs[column.property].focus()
        }, 20)
      }
    },
    changeData(item) {
      console.log('wew', item)
    },
    wiew(item) {
      console.log('2222', item)
      // item.edit = true
      this.$set(item, 'edit', true)
    },
    searchr() {
      this.pageIfon.page = 1
      this.exchangedata()
    },
    reset() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.keyword = null
      this.exchangedata()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
